<!-- Katalysatoren tabs + list, identical in all three branches except the list/item classes. -->
<ng-template #catalysts let-listClass="listClass" let-itemClass="itemClass">
  <div class="catalyst-tabs">
    @for (tab of catalystTabs; track tab; let i = $index) {
      <button
        type="button"
        class="catalyst-tab"
        [class.active]="activeCatalystTab() === i"
        (click)="selectCatalystTab(i)"
      >
        {{ tab }}
      </button>
    }
  </div>
  <div [class]="listClass" [appV3TabPanel]="activeCatalystTab()">
    @for (catalyst of activeCatalysts(); track catalyst.title) {
      <div [class]="itemClass">
        <h3 class="catalyst-title">{{ catalyst.title }}</h3>
        <p class="catalyst-description">{{ catalyst.text }}</p>
      </div>
    }
  </div>
</ng-template>

@if (visible()) {
  @if (isZeroDesktop() || isFinnetDesktop()) {
    <div class="content-grid">
      <div class="column">
        @if (title()) {
          <div class="item">
            @if (isZeroDesktop()) {
              <div class="quote">
                <span class="quote-notch"></span>
                <p class="title">{{ title() }}</p>
              </div>
            } @else {
              <h3 class="title">{{ title() }}</h3>
            }
            <p class="description">{{ description() }}</p>
          </div>
        }

        @if (hasHeadlines()) {
          @if (isZeroDesktop()) {
            <div class="item-title-row">
              <span class="item-title">Top Headlines</span>
              <span class="count">· {{ headlines().length }}</span>
            </div>
          }
          <div class="headline-list">
            @for (headline of headlines(); track $index) {
              <div class="headline-item">
                <p class="headline-title" [innerHTML]="formatText(headline.title) | textClean"></p>
                @if (headline.body) {
                  <p
                    class="headline-description"
                    [innerHTML]="formatText(headline.body) | textClean"
                  ></p>
                }
                @if (headline.date) {
                  @if (isZeroDesktop()) {
                    <div class="headline-tags">
                      <span class="headline-tag">{{ headline.date }}</span>
                    </div>
                  } @else {
                    <span class="headline-date">{{ headline.date }}</span>
                  }
                }
              </div>
            }
          </div>
        }
      </div>
      <div class="divider"></div>
      <div class="column">
        @if (hasCatalysts()) {
          @if (isZeroDesktop()) {
            <div class="item-title-row">
              <span class="item-title">Katalysatoren</span>
              <span class="count">· {{ activeCatalysts().length }}</span>
            </div>
          } @else {
            <div class="finnet-item-title-row">
              <span class="finnet-item-title-notch"></span>
              <span class="finnet-item-title-label"
                >Katalysatoren · {{ activeCatalysts().length }}</span
              >
            </div>
          }
          <ng-container
            *ngTemplateOutlet="
              catalysts;
              context: { listClass: 'catalyst-list', itemClass: 'catalyst-item' }
            "
          ></ng-container>
        }
      </div>
    </div>
  } @else if (isFinnet()) {
    @if (title()) {
      <div class="card">
        <div class="header">
          <h3 class="header-label">News</h3>
          @if (updatedAt()) {
            <app-time-ago
              class="updated-at"
              [updatedAt]="updatedAt()"
              format="compact"
            ></app-time-ago>
          }
        </div>
        <h3 class="title">{{ title() }}</h3>
        <p class="description">{{ description() }}</p>
      </div>
    }

    @if (hasHeadlines()) {
      <div class="card headlines-card">
        <h3 class="header-label">Top Headlines</h3>
        <div class="headline-list">
          @for (headline of headlines(); track $index; let i = $index) {
            <div class="headline-item">
              <button
                type="button"
                class="headline-title-link"
                [attr.aria-expanded]="isHeadlineExpanded(i)"
                (click)="toggleHeadline(i)"
                [innerHTML]="formatText(headline.title) | textClean"
              ></button>
              @if (isHeadlineExpanded(i) && headline.body) {
                <p
                  class="headline-description"
                  [innerHTML]="formatText(headline.body) | textClean"
                ></p>
              }
              @if (headline.date) {
                <span class="headline-date">{{ headline.date }}</span>
              }
            </div>
          }
        </div>
      </div>
    }

    @if (hasCatalysts()) {
      <div class="card catalysts-card">
        <h3 class="header-label">Katalysatoren</h3>
        <ng-container
          *ngTemplateOutlet="
            catalysts;
            context: { listClass: 'catalyst-list', itemClass: 'catalyst-item' }
          "
        ></ng-container>
      </div>
    }
  } @else {
    @if (title()) {
      <div class="eyebrow">
        <span class="notch"></span>
        <span class="header-label">Aktuell</span>
      </div>
      <div class="card">
        <h3 class="title">{{ title() }}</h3>
        <p class="description">{{ description() }}</p>
      </div>
    }

    @if (hasHeadlines()) {
      <div class="eyebrow headlines-header">
        <span class="notch"></span>
        <span class="header-label">Top Headlines</span>
        <span class="count">{{ headlines().length }}</span>
      </div>
      <div class="headline-cards">
        @for (headline of headlines(); track $index; let i = $index) {
          <div class="headline-card">
            <div
              class="headline-row"
              role="button"
              tabindex="0"
              [attr.aria-expanded]="isHeadlineExpanded(i)"
              (click)="toggleHeadline(i)"
              (keyup.enter)="toggleHeadline(i)"
              (keydown.space)="$event.preventDefault(); toggleHeadline(i)"
            >
              <p class="headline-title" [innerHTML]="formatText(headline.title) | textClean"></p>
              <!-- Decorative: the row is the button (axe nested-interactive). -->
              <span
                class="headline-toggle"
                [class.expanded]="isHeadlineExpanded(i)"
                aria-hidden="true"
              >
                <img
                  class="headline-toggle-icon"
                  [src]="backIconSrc()"
                  width="44"
                  height="44"
                  alt=""
                />
              </span>
            </div>
            @if (isHeadlineExpanded(i) && headline.body) {
              <p
                class="headline-description"
                [innerHTML]="formatText(headline.body) | textClean"
              ></p>
            }
            @if (headline.date) {
              <div class="headline-tags">
                <span class="headline-tag">{{ headline.date }}</span>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (hasCatalysts()) {
      <div class="eyebrow catalysts-header">
        <span class="notch"></span>
        <span class="header-label">Katalysatoren</span>
        <span class="count">{{ activeCatalysts().length }}</span>
      </div>
      <ng-container
        *ngTemplateOutlet="
          catalysts;
          context: { listClass: 'catalyst-cards', itemClass: 'catalyst-card' }
        "
      ></ng-container>
    }
  }
}
